<template>
  <v-container fluid>
    <v-row v-show="this.id">
      <v-col cols="12" md="5">
        <v-card class="pa-2">
          <v-card-title>
            <h4>
              Détail du dossier concerné
              {{ this.$store.getters["Auth/get_selected_doc"].document.documentType.description }}
            </h4>
            <v-spacer></v-spacer>
            <v-chip label small outlined
              :color="`${this.$store.getters['Auth/get_selected_doc'].document.free ? 'green' : 'red'}`">
              {{ `${this.$store.getters['Auth/get_selected_doc'].document.free ? "Gratuit" : "Payant"}` }}
            </v-chip>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <b>Objet du dossier :</b>
            {{ this.$store.getters["Auth/get_selected_doc"].document.object }}
            <v-spacer class="my-1"></v-spacer>
            <b>Date/heure de publication du dossier :</b>
            {{
              this.$store.getters["Auth/get_selected_doc"].document.publiDate
              | moment("dddd, Do MMMM YYYY à hh:mm:ss A Z")
            }}
            <v-spacer class="my-1"></v-spacer>
            <b>Date/heure limite de remise des Offres/Propositions/plis :</b>
            {{
              this.$store.getters["Auth/get_selected_doc"].document.deadline
              | moment("dddd, Do MMMM YYYY à HH:mm:ss A Z")
            }}
            <v-spacer class="my-1"></v-spacer>
            <b>Date/heure d’ouverture des Offres/Propositions/plis :</b>
            {{
              this.$store.getters["Auth/get_selected_doc"].document.date_opening
              | moment("dddd, Do MMMM YYYY à HH:mm:ss A Z")
            }}
            <v-spacer class="my-1"></v-spacer>
            <div v-if="this.$store.getters['Auth/get_selected_doc'].document.documentType.status != 2 &&
                this.$store.getters['Auth/get_selected_doc'].document.documentType.status != 3 &&
                this.$store.getters['Auth/get_selected_doc'].document.documentType.status != 5
                ">
              <b>Nombre de Consultants/Cabinets retenus sur la liste restreinte • </b>
              {{ this.$store.getters["Auth/get_selected_doc"].document.selected_users.length }}
              <v-spacer class="my-1"></v-spacer>
              <b>Nombre de Manifestations d’Intérêts reçues • </b>
              {{
                this.$store.getters["Auth/get_selected_doc"].document.not_selected_users.length +
                this.$store.getters["Auth/get_selected_doc"].document.selected_users.length
              }}
              <v-spacer class="my-1"></v-spacer>
            </div>
          </v-card-text>
        </v-card>

        <v-card v-if="this.$store.getters['Auth/get_selected_doc'].document.documentType.status != 2 &&
            this.$store.getters['Auth/get_selected_doc'].document.documentType.status != 3 &&
            this.$store.getters['Auth/get_selected_doc'].document.documentType.status != 5
            " class="mt-2  ">
          <v-card-title>
            <h4>Transmission de lettre aux consultants/candidats</h4>
          </v-card-title>
          <v-card-text>
            <v-select :items="this.$store.getters['Auth/get_all_legal_form'].letter_type"
              label="Sélectionner le type de lettre à envoyer aux consultants/candidats" v-model="letter.type"
              item-text="description" item-value="status"></v-select>
            <v-file-input v-model="letter.file" placeholder="Charger le fichier" label="Joindre la lettre à envoyer"
              multiple prepend-icon="mdi-paperclip">
              <template v-slot:selection="{ text }">
                <v-chip small label color="primary">{{ text }}</v-chip>
              </template>
            </v-file-input>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" small class="white--text " block @click="addLetter">
              <v-icon small class="mr-2" dark>mdi-cloud-upload</v-icon>ENVOYER LA LETTRE AUX CONSULTANTS/CANDIDATS
              CONCERNES
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card class="mt-2" v-if="profile == 6 && this.$store.getters['Auth/get_selected_doc'].document.valid == false">
          <v-card-title id="v-step-0">
            <h4>Répondre à la demande</h4>
          </v-card-title>
          <v-card-text>
            <!-- Menu déroulant pour le choix "Valider" ou "Non Valider" -->
            <v-select v-model="isValidChoice" :items="['Je valide le dossier', 'Dossier non Validé']" label="Choix de validation"></v-select>

            <!-- Champs qui s'affichent lorsque "Valider" est choisi -->
            <div v-if="isValidChoice === 'Je valide le dossier'">
              <v-file-input v-model="docValidation.file" multiple label="Joindre la lettre" truncate-length="15">
                <template v-slot:selection="{ text }">
                  <v-chip small label color="primary">{{ text }}</v-chip>
                </template>
              </v-file-input>
            </div>

            <!-- Champs qui s'affichent lorsque "Non Valider" est choisi -->
            <div v-if="isValidChoice === 'Dossier non Validé'">
              <v-file-input v-model="docObs.file" multiple label="Joindre le fichier des observations" truncate-length="15">
                <template v-slot:selection="{ text }">
                  <v-chip small label color="primary">{{ text }}</v-chip>
                </template>
              </v-file-input>
            </div>
            <v-btn small color="primary" class="ma-2 white--text" :loading="this.$store.getters['Auth/loadDoc']" block
              @click="submitResponse">
              <v-icon class="mr-2" dark>mdi-cloud-upload</v-icon>Envoyer
            </v-btn>
          </v-card-text>
        </v-card>
        <v-card class="mt-2">
          <v-card-title>
            <h4>Traçabilité des téléchargements du dossier concerné</h4>
            <v-spacer></v-spacer><v-chip class="ma-2">{{
              this.$store.getters["Auth/get_selected_doc"].downloaded_nb
            }}</v-chip>
          </v-card-title>
          <v-card-text>
            <v-list-item v-for="item in traceability()" :key="item.id">
              <v-list-item-content>
                <v-list-item-subtitle class="text-truncate font-weight-bold">
                  Type : {{ item.user.company ? "Entreprise" : "Individu" }}
                </v-list-item-subtitle>
                <v-list-item-subtitle class="text-truncate font-weight-bold"
                  v-text="item.user.email"></v-list-item-subtitle>
                <v-list-item-subtitle class="">
                  {{ item.loadedAt | moment("dddd, Do MMMM YYYY à HH:mm:ss A Z") }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="7">
        <v-row>
          <v-col class="pb-0">
            <v-card v-if="this.$store.getters['Auth/get_selected_doc'].document.notice">
              <v-card-title>
                <h4>Référence de l’avis rattaché au dossier</h4>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row>
                  <v-list-item class="block text-truncate">
                    <v-list-item-content>
                      <v-list-item-title class="primary--text text-truncate font-weight-bold"
                        v-text="this.$store.getters['Auth/get_selected_doc'].document.notice.object"></v-list-item-title>

                      <v-list-item-subtitle class="text-truncate secondary--text">{{
                        this.$store.getters["Auth/get_selected_doc"].document.notice.publiDate
                        | moment("dddd, Do MMMM YYYY à HH:mm:ss")
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="mb-2">
              <v-card-title>
                <h4>Liste des additifs rattachés au dossier</h4>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row>
                  <v-list-item v-for="item in this.$store.getters['Auth/getDocAdd']" :key="item.id">
                    <v-list-item-content>
                      <v-list-item-title class="primary--text text-truncate font-weight-bold"
                        v-text="item.object"></v-list-item-title>
                      <v-list-item-subtitle class="secondary--text">
                        {{ item.publiDate | moment("dddd, Do MMMM YYYY à HH:mm:ss A Z") }}
                      </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-btn small icon>
                        <v-icon color="grey lighten-1" @click="ShowTheRevision(item)">mdi-eye</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-card v-if="!additif">
          <v-card-title>
            <h4>
              <!--Aperçu -->
              {{ this.$store.getters["Auth/get_selected_doc"].document.documentType.description }}
            </h4>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 62em !important; overflow: hidden">
            <VueDocPreview style="height: 100%" v-if="this.$store.getters['Auth/get_selected_doc'].document.fileExtension == 'doc' ||
              this.$store.getters['Auth/get_selected_doc'].document.fileExtension == 'docx' ||
              this.$store.getters['Auth/get_selected_doc'].document.fileExtension == 'xls' ||
              this.$store.getters['Auth/get_selected_doc'].document.fileExtension == 'xlsx' ||
              this.$store.getters['Auth/get_selected_doc'].document.fileExtension == 'XLS' ||
              this.$store.getters['Auth/get_selected_doc'].document.fileExtension == 'XLSX'
              " :value="this.$store.getters['Auth/get_selected_doc'].document.fileLink" type="office" />
            <vue-friendly-iframe v-if="this.$store.getters['Auth/get_selected_doc'].document.fileExtension == 'pdf'"
              :src="this.$store.getters['Auth/get_selected_doc'].document.fileLink" frameborder="0"
              loading="lazy"></vue-friendly-iframe>
          </v-card-text>
        </v-card>
        <v-card v-if="additif">
          <v-card-title>
            <h4>{{ Tdr_Ob.object }}</h4>
            <v-spacer></v-spacer>
            <h6>Date : {{ Tdr_Ob.publiDate | moment("dddd, Do MMMM YYYY à HH:mm:ss A Z") }}</h6>
          </v-card-title>
          <v-divider></v-divider>
          <v-divider></v-divider>
          <VueDocPreview v-if="Tdr_Ob.fileType == 'doc' ||
            Tdr_Ob.fileType == 'docx' ||
            Tdr_Ob.fileType == 'xls' ||
            Tdr_Ob.fileType == 'xlsx' ||
            Tdr_Ob.fileType == 'XLS' ||
            Tdr_Ob.fileType == 'XLSX'
            " :value="Tdr_Ob.fileLink" type="office" />
          <v-card-text>
            <v-row>
              <vue-friendly-iframe v-if="Tdr_Ob.fileType == 'pdf'" :src="Tdr_Ob.fileLink" class="w-62em" frameborder="0"
                loading="lazy"></vue-friendly-iframe>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import { mapActions } from "vuex";
import VueDocPreview from "vue-doc-preview";

export default {
  components: { DatePicker, VueDocPreview },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data: () => ({
    filtered: [],
    Tdr_Ob: "",
    addi: {
      objet: "",
      publi_date: new Date(),
      file: []
    },
    letter: {
      type: 0,
      file: []
    },
    report: {
      type: 0,
      date: null
    },
    ppm: [],
    docObs: {
      file: [],
      description: ""
    },
    docValidation: {
      file: [],
    },
    isValidChoice: null,
    additif: false,
    items: [
      {
        text: "Tableau de bord",
        disabled: false,
        href: "/dashboard"
      },
      {
        text: "Mes Documents",
        disabled: false,
        href: "/notice"
      },
      {
        text: "Détails du document",
        disabled: true
      }
    ]
  }),
  computed() {
    console.log(this.$store.getters["Auth/get_selected_doc"].documentType.title);
  },
  created() {
    this.$store.dispatch("Auth/getDoc", this.id);
    this.$store.dispatch("Auth/loadDocAdd", this.id);

    let Virt = [];
    Virt = JSON.parse(localStorage.getItem("userData"));
    this.profile = Virt.profile.status;
    this.user_data = Virt;
  },
  methods: {
    ...mapActions({
      extension_addD: "Auth/extension_addD"
    }),
    ShowTheObservation(value) {
      this.$store.dispatch("Auth/getObservation", value);
      console.log(this.$store.dispatch("Auth/getObservation", value));
      this.dialog2 = !this.dialog2;
    },
    traceability() {
      return this.$store.getters["Auth/get_selected_doc"].download_list;
    },
    async ShowTheRevision(tdr) {
      let td = tdr;
      this.Tdr_Ob = td;
      console.log(td);
      this.additif = !this.additif;
    },

    async submitResponse() {
      this.isLoading = true;
      try {
        if (this.isValidChoice === 'Je valide le dossier') {
          // Call the validatePPM API here
          console.log(this.id);
          const formData = new FormData();
          formData.append("doc_id", this.id);
          formData.append('file_letter', this.docValidation.file[0]);
          const response = await this.$store.dispatch("Auth/validateDoc", formData);
          console.log(response); // Handle the response
        } else if (this.isValidChoice === 'Dossier non Validé') {
          // Call the addPpmObservation API here
          const formData = new FormData();
          formData.append("doc_id", this.id);
          formData.append('file', this.docObs.file[0]);
          const response = await this.$store.dispatch("Auth/addDocumentObservation", formData); // Replace with actual API call
          this.isValidChoice = "";
          this.docObs.file = null;
          console.log(response); 
        }
      } catch (error) {
        console.error(error); // Handle errors
      } finally {
        this.isLoading = false;
      }
    },
  }
};
</script>
<style>
.w-62em {
  height: 62em !important;
  width: 100% !important;
}

.v-card__text {
  width: 100% !important;
}

.vue-friendly-iframe iframe {
  width: 100% !important;
  height: 62em !important;
}

.vue-daterange-picker {
  width: 100%;
}

.mx-datepicker {
  width: 100%;
}
</style>
  